export default function app(state = {
	rendered: false
}, action) {
	switch(action.type) {
		case 'RENDERED_APP':
			return { ...state, rendered: true };
		default:
			return state;					
	}
}


// WEBPACK FOOTER //
// ./src/reducers/app.js